import { useState } from "react";
import { useTranslation } from "react-i18next";
import HeroDatacenter from "./components/HeroDatacenter";
import FeaturesDatacenter from "./components/FeaturesDatacenter";
import SolucionesDatacenter from "./components/SolucionesDatacenter";
import QuoteModal from "@/components/feature/QuoteModal";
import InfoModal from "@/components/feature/InfoModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Navbar from "@/pages/home/components/Navbar";
import InternalCTASection from "@/components/feature/InternalCTASection";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

export default function DatacenterPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const openModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setModalType(null), 300);
  };

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <main>
          <HeroDatacenter onOpenQuote={openQuote} />
          <FeaturesDatacenter />
          <SolucionesDatacenter onOpenModal={openModal} />

          <InternalCTASection
            tag={t("dc.cta.tag")}
            title={t("dc.cta.title")}
            highlight="Openlab Secure"
            subtitle={t("dc.cta.subtitle")}
            buttonLabel={t("dc.cta.button")}
            homeButtonLabel={t("dc.cta.homeButton")}
            onQuote={() => openQuote("Datacenter e Infraestructura")}
            image="https://readdy.ai/api/search-image?query=Team%20of%20data%20center%20engineers%20collaborating%20and%20smiling%20in%20a%20modern%20server%20room%2C%20warm%20ambient%20lighting%20mixed%20with%20blue%20LED%20glow%2C%20professional%20editorial%20photography%2C%20human%20centered%2C%20soft%20depth%20of%20field&width=1600&height=900&seq=dc-cta-human-01&orientation=landscape"
          />
        </main>

        <LandingFooter pageName="Infraestructura Critica" />
      </LanguageTransitionWrapper>
      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <InfoModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalType={modalType}
        onOpenQuote={(service) => {
          closeModal();
          openQuote(service);
        }}
      />
      <WhatsAppFloat />
    </div>
  );
}